"use strict";
function readBlobAsText(blob) {
    return readBlobAs(blob, "string");
}
exports.readBlobAsText = readBlobAsText;
function readBlobAsArrayBuffer(blob) {
    return readBlobAs(blob, "buffer");
}
exports.readBlobAsArrayBuffer = readBlobAsArrayBuffer;
function readBlobAs(blob, mode) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (e) {
            resolve(e.target.result);
        };
        switch (mode) {
            case "string":
                reader.readAsText(blob);
                break;
            case "buffer":
                reader.readAsArrayBuffer(blob);
                break;
        }
    });
}
